var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSettingYellow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    transform: "translate(0 0)",
    fill: "#fefbe8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18,1A17,17,0,0,0,5.979,30.021,17,17,0,0,0,30.021,5.979,16.889,16.889,0,0,0,18,1m0-1A18,18,0,1,1,0,18,18,18,0,0,1,18,0Z",
    transform: "translate(0 0)",
    fill: "#e5b357"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.014,13.5A2.316,2.316,0,0,1,22.5,11.339a9.181,9.181,0,0,0-1.111-2.677,2.347,2.347,0,0,1-.942.2,2.311,2.311,0,0,1-2.114-3.253A9.153,9.153,0,0,0,15.661,4.5a2.314,2.314,0,0,1-4.322,0A9.181,9.181,0,0,0,8.663,5.611,2.311,2.311,0,0,1,6.548,8.864a2.271,2.271,0,0,1-.942-.2A9.384,9.384,0,0,0,4.5,11.344a2.316,2.316,0,0,1,0,4.322,9.181,9.181,0,0,0,1.111,2.677,2.312,2.312,0,0,1,3.052,3.052A9.235,9.235,0,0,0,11.344,22.5a2.31,2.31,0,0,1,4.312,0,9.181,9.181,0,0,0,2.677-1.111,2.314,2.314,0,0,1,3.052-3.052A9.235,9.235,0,0,0,22.5,15.666,2.327,2.327,0,0,1,21.014,13.5Zm-7.472,3.745a3.75,3.75,0,1,1,3.75-3.75A3.749,3.749,0,0,1,13.542,17.245Z",
    transform: "translate(4.5 4.5)",
    fill: "#efb041"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingYellow);
export default __webpack_public_path__ + "static/media/setting_yellow.0a7d64916934375afef64447b3e50a78.svg";
export { ForwardRef as ReactComponent };